export default __webpack_public_path__ + "static/media/right.ebb2fb69.svg";